module.exports = __webpack_public_path__ + "static/media/scholarActivitiesActive.52c03609.svg";